import {Chain, createPublicClient, http} from "viem";
import {useQuery} from "@tanstack/react-query";

export default function useIsContract({
                                          address,
                                          chain,
                                          enabled,
                                      }: {
    address: string,
    chain: Chain,
    enabled?: boolean
}) {
    return useQuery<boolean>({
        queryKey: ["is_contract", chain?.id, address],
        queryFn: async () => {
            if (!chain) return false;
            if (!address) return false;
            const publicClient = createPublicClient({
                chain,
                transport: http()
            })
            const res = await publicClient.getCode({address: address as `0x${string}`})
            return res !== null && res !== undefined;
        },
        enabled
    });
}